<template>
	<event-color-wheel v-model="color" @clickset="colorSet" @mousedown="stopThat" @click="stopThat"></event-color-wheel>
</template>

<script setup lang="ts">
import EventColorWheel from "@fd/editors/color/EventColorWheel.vue";
import {ref, computed} from "vue";

const props = defineProps<{}>();
const emit = defineEmits(["action"]);

const color = ref<number>(0);

function colorSet() {
	emit("action", PALETTE[color.value]);
}

/** To prevent editor loosing focus when user click the wheel */
function stopThat(e: MouseEvent) {
	e.preventDefault();
	e.stopPropagation();
}

function hslToRgb(h: number, s: number, l: number): string {
	s /= 100;
	l /= 100;

	const c = (1 - Math.abs(2 * l - 1)) * s;
	const x = c * (1 - Math.abs((h / 60) % 2 - 1));
	const m = l - c / 2;

	let r = 0, g = 0, b = 0;

	if (h >= 0 && h < 60) {
		r = c;
		g = x;
		b = 0;
	} else if (h >= 60 && h < 120) {
		r = x;
		g = c;
		b = 0;
	} else if (h >= 120 && h < 180) {
		r = 0;
		g = c;
		b = x;
	} else if (h >= 180 && h < 240) {
		r = 0;
		g = x;
		b = c;
	} else if (h >= 240 && h < 300) {
		r = x;
		g = 0;
		b = c;
	} else if (h >= 300 && h < 360) {
		r = c;
		g = 0;
		b = x;
	}

	r = Math.round((r + m) * 255);
	g = Math.round((g + m) * 255);
	b = Math.round((b + m) * 255);

	return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}

function pickLightness(h: number) {
	const l = [50, 45, 40, 43, 45, 50, 52, 55, 60, 55, 55, 55];
	return l[h / 30];
}

function generateTextColorPalette(): string[] {
	const hues = Array.from({length: 12}, (_, i) => i * 30);
	const palette: string[] = [];

	for (const h of hues) {
		let s = 90; // Saturation stays high for vibrancy
		let l = pickLightness(h);
		palette.push(hslToRgb(h, s, l));
	}
	palette.splice(0, 0, "transparent");	// 0 index means transparent

	return palette;
}

const PALETTE:string[] = generateTextColorPalette();
</script>

<style>

</style>